import * as React from 'react';
import { connect } from 'react-redux';
import { Loader } from '@kaleyra/emmy';
import '@kaleyra/emmy/dist/main.css';
import "@kaleyra/kds/dist/main.css";
import { KYCStatus } from '../../interface';
import { IStateType } from '../../store/models/root.interface';
import {
	getLoginIsValid,
	getLoginSuccess,
	requestLogin,
	requestLogout,
} from '../../store/login';
import FullApp from './FullApp';
import { requestObject } from '../../store/Object';
import { inactivityTimeLimit, Instances } from '../../constants';
import { checkInactivity } from '../../utils';

// import GuestFlow from './GuestFlow';

export type MapStateType = {
	success: boolean;
	valid: boolean;
	emailId: string;
	kycStatus: KYCStatus;
	doesExist: boolean;
};

export type DispatchPropsType = {
	onLoad: () => void;
	backToParentAccount: (data: any, callBack: any) => void;
	requestLogout: () => void;
};

const App: React.FC<MapStateType & DispatchPropsType> = ({
	success,
	valid,
	kycStatus,
	emailId,
	doesExist,
	onLoad,
	backToParentAccount,
	requestLogout
}) => {
	
	React.useEffect(() => {
		if (!localStorage.getItem('for-user-id')) {
			document.cookie = "is_parent_as_child_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		}
		onLoad();
		checkInactivity(inactivityTimeLimit)
	}, []);

	return valid ? (
		success ? (
			<>
				<FullApp kycStatus={kycStatus} doesExist={doesExist} emailId={emailId} onLoad={onLoad} backToParentAccount={backToParentAccount} requestLogout={requestLogout} />
			</>
		) : (
			<Loader />
		)
	) : (
		<Loader />
	);
};

const mapStateToProps = (state: IStateType) => ({
	success: getLoginSuccess(state),
	valid: getLoginIsValid(state),
	// add a selector
	kycStatus: state?.profile?.fullProfile?.kyc_status,
	doesExist: state?.key?.doesExist,
	emailId: state?.profile?.fullProfile?.email
});

const mapDispatchToProps = {
	onLoad: () => requestLogin(),
	backToParentAccount: (data: any, callBack: any) =>
		requestObject(
			Instances.ParentLogoutAsSubaccount,
			undefined,
			undefined,
			'POST',
			true,
			true,
			data,
			callBack
		),
	requestLogout: () => requestLogout()
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(App);
